module.exports = __webpack_public_path__ + "static/media/pos_device_on.22a5173a.svg";